/**
 * @file displaySize.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-16
 * @modified 2026-10-16
 * @description Is this display a laptop, or bigger? One breakpoint for every
 *              screen that lays itself out differently on a larger display
 *              (Cam, 16 Oct 2026: Xero Reports' filters on one row, Add Bill's
 *              PDF preview open wide by default — "anything bigger than
 *              laptop").
 *
 *              A laptop is up to 1680 px wide — the width the Blend Calculator
 *              already called a laptop display (it tucks the customer details
 *              away at or below it). Bigger than that is an external monitor.
 *
 *              CSS cannot import this, so the stylesheets that follow it write
 *              the same width: `@media (min-width: 1681px)` (bigger than a
 *              laptop) / `@media (max-width: 1680px)` (a laptop or smaller).
 *              Change them together.
 */

/** The widest display that is still a laptop, in CSS pixels. */
export const LAPTOP_MAX_WIDTH = 1680;

/** A laptop or smaller. */
export const LAPTOP_QUERY = `(max-width: ${LAPTOP_MAX_WIDTH}px)`;

/** Bigger than a laptop. */
export const LARGER_THAN_LAPTOP_QUERY = `(min-width: ${LAPTOP_MAX_WIDTH + 1}px)`;

/** Is the display bigger than a laptop, right now? False where it cannot be told. */
export function isLargerThanLaptop() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(LARGER_THAN_LAPTOP_QUERY).matches;
}
